import { use } from 'react';

import { EyeOpenIcon, HeartIcon, IconText, PriceSpeech } from '@motorway/mw-highway-code';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { VehicleCard } from 'Storybook/components/local/VehicleCard';

import { getAuctionStats } from '../../useOfferPositioningExperiment/helpers/getAuctionStats';
import { SellerConfirmationExperimentProps } from '../SellerConfirmationExperiment.types';

import styles from './SellerConfirmationVehicle.scss';

export const SellerConfirmationVehicle = ({ image, mileage, offer } : SellerConfirmationExperimentProps) => {
  const { vehicleLookupState: vehicle } = use(VehicleLookupContext);
  const { shortlists, views } = getAuctionStats(offer.offerExpiry);
  const bids = (offer.bids?.length ?? 0) + 1;

  return <VehicleCard
    append={<div className={styles.stats}>
      <span>Insights</span>
      {!!views && <IconText
        icon={(props) => <EyeOpenIcon {...props} filled={false} />}
        text={views}
        variant="xsmall--small"
      />}
      {!!shortlists && <IconText
        icon={(props) => <HeartIcon {...props} filled={false} />}
        text={shortlists}
        variant="xsmall--small"
      />}
      {!!bids && <IconText
        icon={(props) => <PriceSpeech {...props} filled={false} />}
        text={bids}
        variant="xsmall--small"
      />}
    </div>}
    image={image ?? ''}
    vehicleDetails={{
      fuel: vehicle.fuel,
      make: vehicle.make?.display_name,
      manufactureYear: vehicle.manufactureYear,
      mileage,
      model: vehicle.model,
      transmission: vehicle.transmission,
    }}
    vrm={vehicle.vrm_pretty}
  />;
};
